import { makeAutoObservable } from 'mobx';

export default class PersonListState {
	public loading: boolean = false;
	public ids: string[] = [];
	public pending: string[] = []; //List of ids that haven't been applied yet e.g. in a people picker.

	private addApi: (id: string) => Promise<void>;
	private removeApi: (id: string) => Promise<void>;

	private myId: string = '';

	constructor(
		addApi: (id: string) => Promise<void>,
		removeApi: (id: string) => Promise<void>,
	) {
		this.addApi = addApi;
		this.removeApi = removeApi;

		makeAutoObservable(this);
	}

	public setMyId(id: string) {
		this.myId = id;
	}

	public canDelete(id: string) {
		return id !== this.myId;
	}

	public setIds(ids: string[]) {
		this.ids = ids;
	}

	public async add(ids: string[], append: boolean = true) {
		//Ignore if it's already here
		let unique = ids.filter((selectedId) => {
			return this.ids.filter((id) => id === selectedId).length === 0;
		});

		this.loading = true;

		for (let index = 0; index < unique.length; index++) {
			const id = unique[index];

			if (append) {
				this.setIds(this.ids.concat([id]));
			} else {
				this.setIds([id].concat(this.ids));
			}
			await this.addApi(id);
		}

		this.loading = false;
	}

	public async remove(id: string) {
		this.loading = true;
		await this.removeApi(id).catch((ex) => {
			console.log('failed: ' + ex);

			//Put them back?
			this.setIds(this.ids.concat([id]));
		});
		this.setIds(this.ids.filter((i) => i !== id));
		this.loading = false;
	}

	public addPending(ids: string[]) {
		this.pending = ids;
	}

	public applyPending() {
		this.add(this.pending, false);
		this.pending = [];
	}
}
